






































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AllConfigurationImages extends Vue {
  @Prop({ type: Array, default: () => [] }) images!: Array<string>;
  @Prop({ type: String, default: "" }) folder!: string;
  @Prop({ type: String, default: "" }) active!: string;

  show = false;

  mounted(): void {
    setTimeout(() => {
      this.show = true;
    }, this.$second(0.5));
  }
}
